import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as CrossIcon } from "../../assets/svg/close.svg";
import { Row, Col } from "react-bootstrap";
// import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import AsyncSelect from "react-select/async";
// import "../masters/customers/customer.css";
import SearchWithAPI from "../searchbox/searchbox.js";

const WidgetCreateModal = ({ widgetId, onSuccess, onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [validations, setValidations] = useState({
        code: "",
        name: "",
        email: "",
        contact_number: "",
        locations: "",
        departments: "",
    });
    useEffect(() => {
        if (widgetId != null) {
          
        }
    }, [widgetId])
    const [emailList, setEmailList] = useState([]);
    const [mobileList, setMobileList] = useState([]);
    const [groupOption, setGroupOption] = useState(null);
 const [locationOption, setLocationOption] = useState(null);
 const [status, setStatus] = useState(true);
const [deviceType, setDeviceType] = useState("Signage");
const [signageCode, setSignageCode] = useState("");
const [domainName, setDomainName] = useState("");

  const handleGroupDropdownChange = (option) => {
    console.log(option);
    setGroupOption(option);
  };
    const handleLocationDropdownChange = (option) => {
    console.log(option);
    setLocationOption(option);
  };
    const handleAddEmail = () => {
        const trimmedEmail = email.trim();

        // Simple email format regex
        const isValidEmail = (email) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!trimmedEmail) {
            setValidations((prev) => ({
                ...prev,
                email: "Email is required",
            }));
            return;
        }

        if (!isValidEmail(trimmedEmail)) {
            setValidations((prev) => ({
                ...prev,
                email: "Invalid email format",
            }));
            return;
        }

        // Clear validation if all is good
        setValidations((prev) => ({
            ...prev,
            email: "",
        }));
        setEmailList((prevList) => [...prevList, trimmedEmail]);

        // Add email logic here (e.g., pushing to a list, sending to backend, etc.)
        console.log("Email added:", trimmedEmail);

        // Optionally clear the input
        setEmail("");
    };
    const handleAddMobile = () => {
        const trimmedMobile = contactNo.trim();
        if (!trimmedMobile) return;

        setMobileList((prevList) => [...prevList, trimmedMobile]);
        setcontactNo(""); // clear input
    }; const handleRemoveEmail = (indexToRemove) => {
        setEmailList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };
    const handleRemoveMobile = (indexToRemove) => {
        setMobileList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };
  
    const [locationsOptions, setlocationsOptions] = useState(null);
    const [multipleGatein, setmultipleGatein] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedDept, setSelectedDept] = useState([]);
    const handleAssignToDropdownChange = (selectedOptions) => {
        console.log(selectedOptions);
        setlocationsOptions(selectedOptions);
    };
    const modalStyle = {
        overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
        modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "916px", overflowY: "auto", minHeight: "fit-content" },
    };

    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contactNo, setcontactNo] = useState("");
 
    return (
        <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>
                <div style={{ color: "#ffffff" }}>
                    <div className="mx-3 mt-1 style-justify-between">
                        <div>                         
                        <div className="add-item-modal-title">{widgetId != null ? "Edit " : "Add "}  widget</div>   
                        <div className="font-13-400-66737E">Enter given below details to create a new widget in your widget gallery.</div>
                        </div>
                        <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
                    </div>
                    <div style={{ padding: "16px 24px" }}>
                         <Row>
                            <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                        <Row>
                            <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                                <div className="field-title mb-2">
                                    Name<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                                <span className="field-error">{validations.code}</span>
                            </Col>
<Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">
             
              Chart Type<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <select className="input-field w-100" value={status} onChange={(e) => { setStatus(e.target.value) }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', border: 'none' }}  >
                           <option value="true">Active</option>
                            <option value="false">In-Active</option>
                        </select>
            <span className="field-error">{validations.location_id}</span>
          </Col>
           <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                      <div className="field-title mb-2">                       
                        Chart Size<span style={{ color: "#FF4444" }}>*</span>{" "}
                      </div>
                      <select className="input-field w-100" value={status} onChange={(e) => { setStatus(e.target.value) }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', border: 'none' }}  >
                           <option value="true">Active</option>
                            <option value="false">In-Active</option>
                        </select>                      <span className="field-error">{validations.location_id}</span>
                    </Col>
                     <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                                <div className="field-title mb-2">
                                    API URL<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                                <span className="field-error">{validations.code}</span>
                            </Col> 
                       <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                                <div className="field-title mb-2">
                                    API Key<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                                <span className="field-error">{validations.code}</span>
                            </Col> 
              

               
                        </Row>
</Col>
<Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
</Col>
</Row>
                        <Row className="mt-3" style={{ width: "670px" }}>
                            <div className="style-justify-end">
                                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                                    Cancel
                                </div>
                                <div className="save-modal-btn style-justify-center" /* onClick={() => saveCustomer()} */
                                >
                                    {widgetId != null ? "Update " : "Save "}
                                </div>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WidgetCreateModal;
